
import Vue from "vue";
import { env } from '@/environment/environment';

export default Vue.extend({
  name: "ReportList",
  props: ['reportList', 'selectedReport', 'selectReport'],
});
